import { Component, OnInit, Input } from '@angular/core';
import { PopMastrService } from '@app/shared/services/pop-mastr.service';  // Import the service


@Component({
  selector: 'app-popup-in',
  templateUrl: './popup-in.component.html',
  styleUrls: ['./popup-in.component.css']
})
export class PopupInComponent implements OnInit {
  @Input() closePopup: () => void;  // Close popup function passed from parent

  category: string = '';
  subcategory: string = '';

  constructor(private popMastrService: PopMastrService) { }

  ngOnInit(): void {}
 
  onSubmit() {
    const data = {
      category: this.category,
      subcategory: this.subcategory
    };

    this.popMastrService.masterMaterial(data).subscribe(
      (response) => {
        console.log('Material created successfully:', response);
        // Optionally close the popup after success
      },
      (error) => {
        console.error('Error creating material:', error);
      }
    );
   

  }
  onClose(): void {
    if (this.closePopup) {
      this.closePopup();  // Trigger the parent's closePopup method
    }
  }
}
